import { SharedContent } from './shared-content';

export const IncomeNetWorthContent = {
  header: `Next, provide your income and liquid net worth`,
  progressLabelIT: 'Internal transfer progress',
  progressLabelITOpenAccount: SharedContent.progressLabelITOpenAccount,
  accountHatPrefix: SharedContent.accountHatPrefix,
};
